import React from 'react'
import styles from './OrderForm.module.css'
import TextArea from '../TextArea'

interface Props {
  localCustomerComment?: string
  onCustomerCommentChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  noBottomSpacing?: boolean
}

function CustomerComment ({ localCustomerComment, onCustomerCommentChange, noBottomSpacing = false }: Props) {
  return (
    <div className={`${styles.commentSection} ${noBottomSpacing ? styles.noBottomSpacing : ''}`}>
      <h4 style={{ marginTop: '1rem' }} className={styles.heading}>
        Skriv en kundkommentar till ordern
      </h4>
      <span className={styles.sectionLabel}>Kundkommentar</span>
      <span className={styles.infoText}>Denna kommentar kommer att visas både mot butiksmedarbetare och kund.</span>
      <TextArea
        placeholder={localCustomerComment ? localCustomerComment : 'Skriv en kundkommentar'} 
        value={localCustomerComment as string} 
        setComment={(e: React.ChangeEvent<HTMLTextAreaElement>) => onCustomerCommentChange(e)}
      />
    </div>
  )
}

export default CustomerComment
